import { render, staticRenderFns } from "./RawShipmentEdit.vue?vue&type=template&id=059a0c66&"
import script from "./RawShipmentEdit.vue?vue&type=script&lang=js&"
export * from "./RawShipmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RawShipmentEdit.vue"
export default component.exports